import React from 'react';
import { Tooltip, Grid } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Text } from '@/components/Typography';

const { useBreakpoint } = Grid;

export interface IconType {
	name: string;
	position: number;
	isComplete: boolean;
	currentStep: number;
	isConsolidated: boolean;
	onStepNagivationClick: (step: number) => Promise<void>;
}

export const StepIcon: React.FC<IconType> = ({
	name,
	position,
	isComplete,
	currentStep,
	isConsolidated,
	onStepNagivationClick
}) => {
	const breakpoints = useBreakpoint();

	function handleStepChange(): void {
		onStepNagivationClick(position);
	}

	function isNextSteps(): boolean {
		return position > currentStep;
	}

	const fullName = name.length > 23 ? I18n.get(name) : undefined;
	const stepText = !!breakpoints.xs ? currentStep + 1 : I18n.get(name);
	const disabled = isConsolidated || (!isComplete && isNextSteps()) ? 'disabled-step' : '';

	if (currentStep === position) {
		return (
			<span className="step-name">
				<Tooltip title={fullName}>
					<Text ellipsis>{stepText}</Text>
				</Tooltip>
			</span>
		);
	}

	return (
		<div className="step-hover">
			<button
				disabled={!!disabled}
				onClick={handleStepChange}
				className={!isConsolidated && currentStep > position ? 'step-checked' : `step-number ${disabled}`}
			>
				{position + 1}
			</button>
			<button
				disabled={!!disabled}
				onClick={handleStepChange}
				className={
					!isConsolidated && currentStep < position
						? `step-number-hovered ${disabled}`
						: 'step-checked-hovered'
				}
			>
				<Tooltip title={fullName}>
					<Text ellipsis>{I18n.get(name)}</Text>
				</Tooltip>
			</button>
		</div>
	);
};
